<form>
    <div class="row row-cols-12 ms-2">
        <span class="ps-0 pb-1 col-12" translate="Settings.OrganisationBrandingSection.IdentityLogo"><app-info-button labelName="Settings.OrganisationBrandingSection.IdentityLogoTooltip"></app-info-button></span>
        <div class="row col-12 mb-2">
            <div class="col-6 ps-0">
                <div class="p-3 mb-2 alert alert-primary workflowPlaceholder border-primary default-font-size brandingImageInfo" role="alert">
                    <span class="lh-sm" translate="Settings.OrganisationBrandingSection.IdentityLogoInfo"></span>
                </div>
                
                <div class="mb-2">
                    <div class="input-group">
                        <input type="file" class="file-input d-none" id="selectedIdentityLogo" accept=".png, .jpeg" (change)="uploadImage('identityLogo', $event)" #fileInputIdentityLogo>
    
                        <input type="text" class="form-control stationeryInputField" [value]="identityLogoName" placeholder="{{ 'Button.ChooseFile' | translate }}">
                        <button class="btn btn-sm default-button browse-button" type="button" (click)="fileInputIdentityLogo.click()"  translate="Button.Browse"></button>
                        <button class="btn btn-sm btn-secondary default-button" type="button"  (click)="removeImage('identityLogo');" [disabled]="branding.identityLogoUrl === null" translate="Button.Reset"></button>
                    </div>
                </div>
            </div>
            <div class="col-6 ps-2 pb-2">
                <div class="image-background"> 
                    <img *ngIf="branding.identityLogoUrl" [src]="branding.identityLogoUrl" alt="{{ 'Settings.OrganisationBrandingSection.IdentityLogo' | translate }}" id="IdentityLogo" class="brandingImage">
                </div>
            </div>
        </div>
    </div>
    
    <div class="row row-cols-12 ms-2">
        <span class="ps-0 pb-1 col-12 " translate="Settings.OrganisationBrandingSection.PlatformLogo"><app-info-button labelName="Settings.OrganisationBrandingSection.PlatformLogoTooltip"></app-info-button></span>
        <div class="row col-12 mb-2">
            <div class="col-6 ps-0">
                <div class="p-3 mb-2 alert alert-primary workflowPlaceholder border-primary default-font-size brandingImageInfo" role="alert">
                    <span class="lh-sm" translate="Settings.OrganisationBrandingSection.PlatformLogoInfo"></span>
                </div>
                
                <div class="mb-2">
                    <div class="input-group">
                        <input type="file" class="file-input d-none" id="selectedPlatformLogo" accept=".png, .jpeg" (change)="uploadImage('platformLogo', $event)" #fileInputPlatformLogo>
    
                        <input type="text" class="form-control stationeryInputField" [value]="platformLogoName" placeholder="{{ 'Button.ChooseFile' | translate }}">
                        <button class="btn btn-sm default-button browse-button" type="button" (click)="fileInputPlatformLogo.click()"  translate="Button.Browse"></button>
                        <button class="btn btn-sm btn-secondary default-button" type="button"  (click)="removeImage('platformLogo');" [disabled]="branding.platformLogoUrl === null" translate="Button.Reset"></button>
                    </div>
                </div>
            </div>
            <div class="col-6 ps-2 pb-2">
                <div class="image-background"> 
                    <img *ngIf="branding.platformLogoUrl" [src]="branding.platformLogoUrl" alt="{{ 'Settings.OrganisationBrandingSection.PlatformLogo' | translate }}" id="logo" class="brandingImage">
                </div>
            </div>
        </div>
    </div>
    
    <div class="row row-cols-12 ms-2">
        <span class="ps-0 pb-1 col-12" translate="Settings.OrganisationBrandingSection.Favicon"><app-info-button labelName="Settings.OrganisationBrandingSection.FaviconTooltip"></app-info-button></span>
        <div class="row col-12 mb-2">
            <div class="col-6 ps-0">
                <div class="p-3 mb-2 alert alert-primary workflowPlaceholder border-primary default-font-size brandingImageInfo" role="alert">
                    <span class="lh-sm" translate="Settings.OrganisationBrandingSection.FaviconInfo"></span>
                </div>
                
                <div class="mb-2">
                    <div class="input-group">
                        <input type="file" class="file-input d-none" id="selectedFavicon" accept=".png, .ico" (change)="uploadImage('favicon', $event)" #fileInputFavicon>
    
                        <input type="text" class="form-control stationeryInputField" [value]="faviconName" placeholder="{{ 'Button.ChooseFile' | translate }}">
                        <button class="btn btn-sm default-button browse-button" type="button" (click)="fileInputFavicon.click()"  translate="Button.Browse"></button>
                        <button class="btn btn-sm btn-secondary default-button" type="button"  (click)="removeImage('favicon');" [disabled]="branding.faviconUrl === null" translate="Button.Reset"></button>
                    </div>
                </div>
            </div>
            <div class="col-6 ps-2 pb-2">
                <div class="image-background"> 
                    <img *ngIf="branding.faviconUrl" [src]="branding.faviconUrl" alt="{{ 'Settings.OrganisationBrandingSection.Favicon' | translate }}" id="favicon" class="brandingImage">
                </div>
            </div>
        </div>
    </div>
    
    <div class="row row-cols-12 ms-2">
        <span class="ps-0 pb-1 col-12" translate="Settings.OrganisationBrandingSection.Watermark"><app-info-button labelName="Settings.OrganisationBrandingSection.WatermarkTooltip"></app-info-button></span>
        <div class="row col-12 mb-2">
            <div class="col-6 ps-0">
                <div class="p-3 mb-2 alert alert-primary workflowPlaceholder border-primary default-font-size brandingImageInfo" role="alert">
                    <span class="lh-sm" translate="Settings.OrganisationBrandingSection.WatermarkInfo"></span>
                </div>
                
                <div class="mb-2">
                    <div class="input-group">
                        <input type="file" class="file-input d-none" id="selectedWatermark" accept=".png, .jpeg" (change)="uploadImage('watermark', $event)" #fileInputselectedWatermark>
    
                        <input type="text" class="form-control stationeryInputField" [value]="watermarkName" placeholder="{{ 'Button.ChooseFile' | translate }}">
                        <button class="btn btn-sm default-button browse-button" type="button" (click)="fileInputselectedWatermark.click()"  translate="Button.Browse"></button>
                        <button class="btn btn-sm btn-secondary default-button" type="button"  (click)="removeImage('watermark');" [disabled]="branding.stampUrl === null" translate="Button.Reset"></button>
                    </div>
                </div>
            </div>
            <div class="col-6 ps-2 pb-2">
                <div class="image-background"> 
                    <canvas id="stampImage"></canvas>
                </div>
            </div>
        </div>
    </div>
</form>